import React from 'react'
import { string } from 'prop-types'

import { ActionLink as CreditasActionLink } from '@creditas/button'
import { styled } from '@creditas/stylitas'

const ActionLink = styled(CreditasActionLink)`
  padding: 0;

  span {
    text-decoration: underline;
  }
`

const Block = styled.div`
  display: grid;
  grid-template-columns: auto 65px;

  b {
    font-weight: bold;
  }

  a {
    text-align: center;
  }
`

const Name = styled.div`
  display: inline-block;
  font-weight: bold;
  margin-bottom: -7.3px;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const ContractUpdateMessage = ({ name, id }) => (
  <Block>
    <div>
      O cliente <Name>{name}</Name> passou para o status &quot;Contrato
      Novo&quot;
    </div>
    <ActionLink href={`/auto-refi/${id}/linha-do-tempo`}>
      Acessar Perfil
    </ActionLink>
  </Block>
)

ContractUpdateMessage.propTypes = {
  name: string.isRequired,
  id: string.isRequired,
}

export { ContractUpdateMessage }
